import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  unresolvedTickets,
} from 'data/dashboard/support-desk';
import TicketStatus from './TicketStatus';
import UnresolvedTickets from './unresolved-tickets/UnresolvedTickets';
import PendingTickets from './PendingTickets';

import CagegorywiseSummaryPieCategory from 'components/categorywise-summary-pie-category/CagegorywiseSummaryPie';
import CagegorywiseSummaryPieSummary from 'components/categorywise-summary-pie-summary/CagegorywiseSummaryPie';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import GreetingCard from 'components/greetings/GreetingCard';
import SupportServicesDateAll from '../charts/support-services-date-all/SupportServicesDateAll';
import SupportServicesCategoryAll from '../charts/support-services-category-all/SupportServicesCategoryAll';
import SupportServicesAssetAll from '../charts/support-services-asset-all/SupportServicesAssetAll';
import SummaryPieAsset from 'components/categorywise-summary-pie-asset/CagegorywiseSummaryPie';
import SupportServicesTreadlineDate from '../charts/support-services-treadline-date/SupportServicesTreadlineDate';
import SupportServicesAgentAll from '../charts/support-services-agent-all/SupportServicesAgentAll';
import SupportServicesTicketInitiatorAll from '../charts/support-services-initiator-all/SupportServicesTicketInitiatorAll';
import SupportServicesTicketCompanyAll from '../charts/support-services-company-all/SupportServicesTicketCompanyAll';
import SupportServicesMonthAll from '../charts/support-services-month-all/SupportServicesMonthAll';
import SelectOption from 'components/select/SelectOption';
import { getDrpCompanies } from 'functions/dropdowns';


const SupportDesk = () => {

  const currentDate = new Date();

  // Set fromDate to the current date with minimum time (midnight)
  currentDate.setHours(0, 0, 0, 0);

  // Set toDate to the current date with maximum time (end of the day)
  const endOfDay = new Date(currentDate);
  endOfDay.setHours(23, 59, 59, 999);

  // Set the state values
  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(endOfDay);
  const [companyId, setCompanyId] = useState('');
  const [companyOptions, setCompanyOptions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData && userData.roleId === 2) {
      navigate('/support-desk/table-view');
    }
    
    const loadCompanies = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await getDrpCompanies(token);
        const options = response.data.map(c => ({ value: c.value, text: c.text }));
        setCompanyOptions([{ value: '', text: 'All Companies' }, ...options]);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };
    loadCompanies();
  }, [navigate]);

  const onSelectHandler = (fromDate, toDate) => {
    setFromDate(fromDate);
    setToDate(toDate);
  };

  const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
    <div className="position-relative">
      <Form.Control
        size="sm"
        ref={ref}
        onClick={onClick}
        value={value}
        className="ps-4"
        onChange={e => {
          console.log({ e });
        }}
      />
      <FontAwesomeIcon
        icon="calendar-alt"
        className="text-primary position-absolute top-50 translate-middle-y ms-2"
      />
    </div>
  ));


  return (
    <>
      <Row className="g-3 mb-3">

        <Col xxl={6}>
          <Row className="g-0 h-100">
            <Col xs={12} className="mb-3">
              <GreetingCard />
            </Col>
            <Col>
              <TicketStatus fromDate={fromDate} toDate={toDate} companyId={companyId} />
            </Col>
          </Row>
        </Col>
        <Col xxl={6}>
          <UnresolvedTickets fromDate={fromDate} toDate={toDate} data={unresolvedTickets} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col xxl={12}>
           <PendingTickets companyId={companyId} />
        </Col>
      </Row>

      <Row className="g-3">
        <Col xxl={12}>
          <div className="d-flex align-items-center mb-0">
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPriority"
            >
              <Form.Label column sm="12" style={{ fontSize: '14px' }}>
                From:
              </Form.Label>
              <Col sm="12">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      marginRight: '20px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <DatePicker
                      selected={fromDate}
                      onChange={date => {
                        setFromDate(date);
                      }}
                      dateFormat="MMM d, yyyy h:mm aa" // Date format with time
                      showTimeSelect
                      timeFormat="hh:mm aa" // 24-hour format, adjust as needed
                      customInput={<GreetingsDateInput />}
                    />
                  </div>
                </div>
              </Col>
            </Form.Group>

            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPriority"
            >
              <Form.Label column sm="12" style={{ fontSize: '14px' }}>
                To:
              </Form.Label>
              <Col sm="12">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      marginRight: '20px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <DatePicker
                      selected={toDate}
                      onChange={date => {
                        setToDate(date);
                      }}
                      dateFormat="MMM d, yyyy h:mm aa" // Date format with time
                      showTimeSelect
                      timeFormat="hh:mm aa" // 24-hour format, adjust as needed
                      customInput={<GreetingsDateInput />}
                    />
                  </div>
                </div>
              </Col>
            </Form.Group>

            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextCompany"
            >
              <Form.Label column sm="12" style={{ fontSize: '14px' }}>
                Company:
              </Form.Label>
              <Col sm="12">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      marginRight: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '200px'
                    }}
                  >
                    <SelectOption
                      options={companyOptions}
                      selectedValue={companyId}
                      handleChange={(e) => setCompanyId(e.target.value)}
                    />
                  </div>
                </div>
              </Col>
            </Form.Group>
          </div>

        </Col>


        {/* <Col xxl={6}>
<SupportServicesSummary />
</Col> */}
        <Col xxl={12}>

          <CagegorywiseSummaryPieSummary fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>


        {/* <Col xxl={12}>
          <SupportServicesDate />
        </Col> */}
        <Col xxl={12}>
          <SupportServicesDateAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <SupportServicesMonthAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <SupportServicesCategoryAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <CagegorywiseSummaryPieCategory fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>

        <Col xxl={12}>
          <SupportServicesAssetAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <SummaryPieAsset fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>

        <Col xxl={12}>
          <SupportServicesAgentAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <SupportServicesTicketInitiatorAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        <Col xxl={12}>
          <SupportServicesTicketCompanyAll fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
        {/* <Col xxl={12}>
          <SupportServicesBounceRateDate />
        </Col> */}

        <Col xxl={12}>
          <SupportServicesTreadlineDate fromDate={fromDate} toDate={toDate} companyId={companyId} />
        </Col>
      </Row>
    </>
  );
};

export default SupportDesk;
